import { apiRequest } from "./apiRequest";

export const contactPostData = async (post) => {

    const api = await apiRequest({
        url: "/leads",
        method: "post",
        body: post,
    });
    console.log({ api })
    return api.data;
};
